import { useState } from 'react';

const CARD_CONFIGS = [
  { rotate: '-3deg', translateX: '-12px', translateY: '8px',  zIndex: 1 },
  { rotate: '2deg',  translateX: '8px',   translateY: '-4px', zIndex: 2 },
  { rotate: '0deg',  translateX: '0px',   translateY: '0px',  zIndex: 3 },
];

export default function StackedCards({ images = [] }) {
  const [hovered, setHovered] = useState(false);
  const displayImages = images.slice(0, 3);

  return (
    <div
      className="stacked-cards"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {displayImages.map((img, i) => {
        const cfg = CARD_CONFIGS[i] || CARD_CONFIGS[2];
        const transform = hovered
          ? `rotate(${cfg.rotate}) translate(${cfg.translateX}, ${cfg.translateY}) scale(1.01)`
          : `rotate(${cfg.rotate}) translate(${cfg.translateX}, ${cfg.translateY})`;
        return (
          <div
            key={i}
            className="stacked-card"
            style={{ zIndex: cfg.zIndex, transform }}
          >
            <img src={img.src} alt={img.alt || `Project image ${i + 1}`} loading="lazy" />
          </div>
        );
      })}
    </div>
  );
}
